import * as React from "react";
import { SVGProps } from "react";

const CvuSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={62}
    height={26}
    viewBox="22 20 62 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="currentColor">
      <path d="M22.55,32c0-6.33,4.81-11.23,10.45-11.23,5.06,0,8.53,3.78,9.52,7.91h-3.69c-.68-2.26-2.67-4.47-5.83-4.47-3.66,0-6.86,3.23-6.86,7.79s3.2,7.79,6.86,7.79c3.2,0,5.21-2.2,5.99-4.47h3.69c-.96,4.03-4.47,7.91-9.68,7.91-5.65,0-10.45-4.9-10.45-11.23Z" />
      <path d="M43.3,21.14h3.82l5.89,16.84,5.89-16.84h3.66l-7.82,21.71h-3.69l-7.76-21.71Z" />
      <path d="M64.7,34.73v-13.59h3.6v13.59c0,2.98,1.8,5.06,4.78,5.06s4.78-2.08,4.78-5.06v-13.59h3.6v13.59c0,4.84-3.32,8.5-8.38,8.5s-8.38-3.66-8.38-8.5Z" />
    </g>
  </svg>
);

export default CvuSimple;
